import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TrxServicesCardPage } from './trxservices-card.page';

const routes: Routes = [
  {
    path: '',
    component: TrxServicesCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class TrxServicesCardPageRoutingModule {}
